module.exports = __webpack_public_path__ + "img/3.e9230e23.webp";